/**
 * Scan status line shown under the phase tabs, mirroring the "Last scan: … ·
 * Re-scan" subtitle on the Repo/Feature drill-down pages: a muted
 * `text-secondary` line whose action is an inline `.btn-link` rather than a
 * prominent button. Reads "Last scan: MM/DD/YYYY  Re-scan"; when nothing has
 * been scanned yet the lead is dropped and the link reads "Scan".
 */
export function ScanFooterLine({
  lastScannedAt,
  busy = false,
  busyLabel = 'Scanning...',
  onScan,
  testId,
  ariaLabel,
  align = 'left',
}: {
  lastScannedAt?: string | null;
  /** Disables the link and shows `busyLabel` while a scan is in flight. */
  busy?: boolean;
  busyLabel?: string;
  onScan: () => void;
  testId?: string;
  ariaLabel?: string;
  /** Horizontal alignment of the line; 'right' tucks it under a table's bottom-right. */
  align?: 'left' | 'right';
}) {
  const label = busy ? busyLabel : lastScannedAt ? 'Re-scan' : 'Scan';
  return (
    <p className="text-secondary text-sm" data-testid="scan-footer" style={align === 'right' ? { textAlign: 'right' } : undefined}>
      {lastScannedAt && <>Last scan: {new Date(lastScannedAt).toLocaleDateString()} </>}
      <button
        type="button"
        className="btn-link"
        onClick={onScan}
        disabled={busy}
        data-testid={testId}
        aria-label={ariaLabel}
      >
        {label}
      </button>
    </p>
  );
}
